import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MaterialModule} from './material/material.module';
import {ConfiguratorComponent, EnumToArrayPipe} from './components/configurator/configurator.component';
import {RequestComponent, SortFilesPipe} from './components/request-page/request.component';
import {NgxFileDropModule} from 'ngx-file-drop';
import {NgSelectizeModule} from 'ng-selectize';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ListComponent} from './components/list/list.component';
import {ApiModule} from './api.module';
import {TemplateDialogComponent} from './components/template-dialog/template-dialog.component';
import {UtilityService} from './utility.service';
import {TranslatePipe} from './translation/translate.pipe';
import {TranslateService} from './translation/translate.service';
import {TRANSLATION_PROVIDERS} from './translation/translation';
import {MatSpinnerOverlayComponent} from './components/mat-spinner-overlay/mat-spinner-overlay.component';
import {ImgFallbackDirective} from './img-fallback.directive';
import { DisclaimerDialogComponent } from './components/request-page/disclaimer-dialog/disclaimer-dialog.component';
import {
  GetExtensionPipe, NumberFormatPipe,
  RemoveExtensionPipe,
  UploadTableComponent
} from './components/request-page/upload-table/upload-table.component';
import {BRtoNPipe, MetadataListComponent} from './components/request-page/metadata-list/metadata-list.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {FileComponentComponent} from './components/request-page/file-component/file-component.component';
import {UploadedDialogComponent} from './components/request-page/uploaded-dialog/uploaded-dialog.component';
import {ConfirmationDialogComponent} from './components/confirmation-dialog/confirmation-dialog.component';
import {FilterPipe} from './filter.pipe';
import {MatDialogModule} from '@angular/material/dialog';
import {DatePickerFormatDirective} from './date-picker-format.directive';
import {MatMomentDateModule} from '@angular/material-moment-adapter';
import {ProtocolDialogComponent} from "./components/protocol-dialog/protocol-dialog.component";
import {FilterInformationFieldsPipe} from "./filterInformationFields.pipe";
import {EditorModule} from "@tinymce/tinymce-angular";


@NgModule({
  declarations: [
    AppComponent,
    ConfiguratorComponent,
    RequestComponent,
    ListComponent,
    EnumToArrayPipe,
    RemoveExtensionPipe,
    GetExtensionPipe,
    NumberFormatPipe,
    SortFilesPipe,
    TemplateDialogComponent,
    TranslatePipe,
    BRtoNPipe,
    MatSpinnerOverlayComponent,
    ImgFallbackDirective,
    DisclaimerDialogComponent,
    UploadedDialogComponent,
    UploadTableComponent,
    MetadataListComponent,
    FileComponentComponent,
    ConfirmationDialogComponent,
    ProtocolDialogComponent,
    FilterPipe,
    FilterInformationFieldsPipe,
    DatePickerFormatDirective
  ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MaterialModule,
        NgxFileDropModule,
        NgSelectizeModule,
        FormsModule,
        ReactiveFormsModule,
        ApiModule,
        DragDropModule,
        MatDialogModule,
        MatMomentDateModule,
        EditorModule

    ],
  providers: [
    UtilityService,
    TranslateService,
    TranslatePipe,
    NumberFormatPipe,
    GetExtensionPipe,
    SortFilesPipe,
    TRANSLATION_PROVIDERS
  ],
  bootstrap: [AppComponent],
  exports: [TemplateDialogComponent, ConfirmationDialogComponent],
  entryComponents: [
    TemplateDialogComponent,
    ConfirmationDialogComponent,
    DisclaimerDialogComponent,
    UploadedDialogComponent,
    ProtocolDialogComponent,
  ],
})
export class AppModule { }
